export default {
	setAccountShareHoldings: (state, accountShareHoldings) => {
		state.accountShareHoldings = accountShareHoldings
	},
	setCashBalance: (state, cashBalance) => {
		state.cashBalance = cashBalance
	},
	setTradingHours: (state, tradingHours) => {
		state.tradingHours = tradingHours
	},
}
